<div class="date-row">
  <div>
    @if (!!date) {
      <rotec-icon-v2
        svgIcon="calendar"
        [color]="dark || isSelected ? 'white' : 'blue'"
      ></rotec-icon-v2>
    }
  </div>
  <div [className]="dark || isSelected ? 'white' : 'blue'">
    {{ date | localizedDate: 'shortDate' }}
  </div>
</div>
